import React, { useEffect } from "react";
import { API } from "@/lib/api";

export default function ModelViewer({ path, poster }) {
  useEffect(() => {
    // Lazy-load model-viewer web component
    import("@google/model-viewer").catch(() => {});
  }, []);

  if (!path) return null;
  const src = `${API}/files/${path}`;

  return (
    <div className="w-full h-full rounded-xl overflow-hidden border border-border bg-muted" data-testid="model-viewer-3d">
      {/* @ts-ignore custom element */}
      <model-viewer
        src={src}
        camera-controls="true"
        auto-rotate="true"
        shadow-intensity="1"
        exposure="0.9"
        environment-image="neutral"
        poster={poster || ""}
        style={{ width: "100%", height: "100%" }}
      >
        <div slot="progress-bar"></div>
      </model-viewer>
    </div>
  );
}
